import { render, staticRenderFns } from "./ModalAdditionalSize.vue?vue&type=template&id=6f62aaa1&scoped=true"
import script from "./ModalAdditionalSize.vue?vue&type=script&lang=js"
export * from "./ModalAdditionalSize.vue?vue&type=script&lang=js"
import style0 from "./ModalAdditionalSize.vue?vue&type=style&index=0&id=6f62aaa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62aaa1",
  null
  
)

export default component.exports